import { flexCenter } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

import { breadcrumbItemHoverStyle, BreadcrumbItemWrapper } from '../../../Breadcrumbs/BreadcrumbItem';
import { folderIconHoverStyles, IconButtonWrapper } from '../BreadcrumbIconButton';

export type FirstItemIconProps = {};

const Wrapper = styled.div`
  ${flexCenter};
  &:hover {
    ${BreadcrumbItemWrapper} {
      ${breadcrumbItemHoverStyle}
    }

    ${IconButtonWrapper} {
      ${folderIconHoverStyles};
    }
  }
`;

const FirstItemIcon: FC<FirstItemIconProps> = ({ children }) => <Wrapper>{children}</Wrapper>;

export default FirstItemIcon;
